import { Outlet } from 'react-router-dom';
import React, { useState } from 'react'
import { sidebarData } from './EmployeeSidebar';
import DashboardSidebar from '../layout/DashboardSidebar';


const EmployeeDeatilsDashboard = () => {

  const [isexpand, setExpanded] = useState(false);

  return (
    <>
      <div className="dashboard-main-section">

        <DashboardSidebar sidebarData={sidebarData} isexpand={isexpand} setExpanded={setExpanded} />
        <div className={isexpand ? "dashboard-main-content-sectionn" : "dashboard-main-content-sectionnn"} style={{ minHeightheight: "105vh" }}>
          <Outlet />
        </div>
      </div>
    </>
  );
};


export default EmployeeDeatilsDashboard;
